export const TENANT_SERVICE_ENDPOINT = {
  TENANT_CATEGORY_MAPPING: '/tenant/categoryMapping'
};
